define.alias("shared/components/shared/plan-recommendation/steps/goal", "calendar/components/shared/plan-recommendation/steps/goal");